import React, { ReactNode, ReactNodeArray, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSettings } from '../../features/slicePathname';
import { extractUtm, writeUtmCookie } from '../../utils/utm';

interface ISiteAddressProps {
  children: ReactNode | ReactNodeArray
}
export const SiteAddress = ({ children }:ISiteAddressProps) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSettings({ pathname }));
  }, [pathname]);

  // Last-touch UTM capture into the shared `cpg_utm` cookie (see utils/utm.ts).
  // Runs once on landing: ads pointing directly at app.cpgjobs.com arrive here with
  // the query params; referrals from www.cpgjobs.com already carry the shared
  // `.cpgjobs.com` cookie. Only overwrite when the URL has >=1 non-page tracking
  // key, so a UTM-less or utm_page-only URL never clears the existing attribution.
  useEffect(() => {
    const utm = extractUtm(new URLSearchParams(window.location.search), window.location.href);
    if (utm) {
      writeUtmCookie(utm);
    }
  }, []);

  if (!pathname) {
    return null;
  }
  return (
    <>
      {children}
    </>
  );
};
